<template>
    <div class="mb-md bg-neutral-lightest rounded p-lg">
        <div v-if="! newTaskType">
            <select-input
                v-model="newTaskType"
                name="new_task_type"
                :options="{ checkbox: 'Kryssruta', text: 'Fritextfält', number: 'Nummerfält', select: 'Select', image: 'Bildväljare', 'multi-select': 'Flervalsväljare', 'file': 'Filväljare' }"
                placeholder="Välj typ av aktivitet"
            />

            <div class="button-group">
                <button class="btn btn-md is-ghost" @click="cancelCreating">
                    Avbryt
                </button>

                <button class="btn btn-md is-primary" disabled>
                    Skapa
                </button>
            </div>
        </div>

        <div v-else>
            <component
                :is="`create-${newTaskType}-task`"
                :task-list-template="null"
                :task-list-id="taskListId"
                @cancel="cancelCreating"
                @added="added"
            />
        </div>
    </div>
</template>
<script>
    import CreateCheckboxTask from '../CreateTask/CreateCheckboxTask';
    import CreateTextTask from '../CreateTask/CreateTextTask';
    import CreateNumberTask from '../CreateTask/CreateNumberTask';
    import CreateSelectTask from '../CreateTask/CreateSelectTask';
    import CreateImageTask from '../CreateTask/CreateImageTask';
    import CreateFileTask from '../CreateTask/CreateFileTask';
    import CreateMultiSelectTask from '../CreateTask/CreateMultiSelectTask';

    export default {
        components: {
            CreateCheckboxTask, // eslint-disable-line vue/no-unused-components
            CreateTextTask, // eslint-disable-line vue/no-unused-components
            CreateNumberTask, // eslint-disable-line vue/no-unused-components
            CreateSelectTask, // eslint-disable-line vue/no-unused-components
            CreateImageTask, // eslint-disable-line vue/no-unused-components
            CreateMultiSelectTask, // eslint-disable-line vue/no-unused-components
            CreateFileTask, // eslint-disable-line vue/no-unused-components
        },
        props: {
            taskListId: {
                required: true,
                type: Number,
            },
        },
        data() {
            return {
                taskListTemplate: null,
                newTaskType: '',
                creatingNew: false,
                editingOrder: false,
            };
        },
        methods: {
            cancelCreating() {
                this.newTaskType = '';
                this.creatingNew = false;
                this.$emit('cancel');
            },
            added(data) {
                this.$emit('added', data);
            },
        },
    };
</script>